import { Component, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { SurveyentryService } from "./shared/surveyentry.service";
import { EnquiryentryService } from "../../enquiry/shared/enquiryentry.service";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { Customer } from "../../customer/shared/customer.model";
import { Employee } from '../../login/shared/employee';
import { CustomerService } from "../../customer/shared/customer.service";
import { CenterlinkService } from "../../customer/shared/centerlink.service";
import { Enquiryno } from "./shared/enquiryno.model";

@Component({
  selector: 'app-surveyentry',
  templateUrl: './surveyentry.component.html',
  styleUrls: ['./surveyentry.component.css']
})
export class SurveyentryComponent implements OnInit {

  displayedColumns: string[] = ['Id', 'Name', 'Mobile', 'DOB', 'AnnualIncome', 'Loanpurpose', 'Interested', 'Amount', 'New'];
  dataSource: MatTableDataSource<Customer>;

  ParentSurveyNo: number;
  IsNewEntry: number; // for new entry
  StaffList: any[] = [];
  selectedStaff: any[] = [];
  enquiryEntryNoList$: any[] = [];
  EnquiryDate: string;
  CentreList: any[] = [];
  AddButtonText: string;
  ErrorText: string;
  readonlyTextBox:false;

  constructor(private router: Router, private route: ActivatedRoute,
    private commonmastersService: CommonmastersService,
    public surveyentryService: SurveyentryService,
    private enquiryentryService: EnquiryentryService,
    private customerService: CustomerService,
    private centerlinkService: CenterlinkService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {

      if (params['Id'] == 101) {
        this.IsNewEntry = 101;
        this.ParentSurveyNo = params['Id'];
      }
      else if (params['Id1'] == 202) {   // edit entry
        this.IsNewEntry = 202;
        this.ParentSurveyNo = params['Id'];
      }
      else if (params['Id'] == 501) { // from customer form
        this.IsNewEntry = 501;
        this.ParentSurveyNo = params['Id1'];
      }
      else if (params['Id'] == 701) { // from customer form
        this.IsNewEntry = 701;
        this.ParentSurveyNo = params['Id1'];
      }
      else {
        console.log(" No action");
        this.IsNewEntry = 0;
      }

    });

    this.resetForm();
    this.getAutogeneratedNumber();
    this.GetStaff();
    this.GetEnquiryNo();
    this.GetCustomers();
    this.GetCentreList();

    if (this.IsNewEntry == 101 || this.IsNewEntry == 501) {
      this.surveyentryService.selectedSurveyentry.Id = 0;
      this.surveyentryService.selectedSurveyentry.Flag = 1;
      this.surveyentryService.selectedSurveyentry.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.GetSurveyEntryBySurvayNo();
      this.GetStaffBySurvayNo();
      // this.readonlyTextBox = true;
      this.AddButtonText = "Save & Edit";
      this.surveyentryService.selectedSurveyentry.Id = +this.ParentSurveyNo;
      this.surveyentryService.selectedSurveyentry.Flag = 2;
      this.surveyentryService.selectedSurveyentry.IsActive = true;
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.surveyentryService.selectedSurveyentry = {
      Id: 0,
      SurveyNo: null,
      SurveyDate: new Date(),
      EnquiryNo: null,
      EnquiryDate: null,
      StatusId: 0,
      TrainingNo: 0,
      Remarks: null,
      ProposedCenter: 0,
      FirstTrainingDate: null,
      SecondTrainingDate: null,
      ThirdTrainingDate: null,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive: true,
      Flag: 1,

      CustomersList: [{
        Id: null,
        CustomerNo: null,
        SurveyNo: 0,
        CustomerBranchId: 0,
        Title: 2,
        FirstName: null,
        LastName: null,
        AliasName: null,
        GenderId: 2,
        DOB: null,
        CategoryId: 0,
        Area: null,
        OccupationId: 0,
        Mobile: null,
        Email: null,
        Father: null,
        Guardian: null,
        GuardianRelationId: 0,
        MartialStatus: 0,
        Nominee: null,
        NomineeRelationId: 0,
        AadharNo: null,
        PANNo: null,
        Tax: null,
        BankAcNo: null,
        BankName: null,
        BankBranchName: null,
        IFSC: null,
        AgentId: 7,
        ExistingLoan: null,
        IdProof: 0,
        IdProofNo: null,
        IdProofIssued: null,
        IdProofValidity: null,
        AddressProofId: 0,
        AddressProofNo: null,
        AddressProofIssued: null,
        AddressProofValidity: null,
        AddressMobile: null,
        AddressPhone: null,
        Address: null,
        Place: null,
        PostOffice: null,
        Pincode: null,
        Village: null,
        Panchayath: null,
        Taluk: null,
        District: 0,
        State: 1,
        CountryId: 1,
        PermanentAddress: null,
        PermanentPlace: null,
        PermanentPostOffice: null,
        PermanentPincode: null,
        PermanentVillage: null,
        PermanentPanchayath: null,
        PermanentTaluk: null,
        PermanentDistrict: 0,
        PermanentState: 1,
        PermanentCountryId: 1,
        OfficeAddress: null,
        OfficePlace: null,
        OfficePostOffice: null,
        OfficePincode: null,
        OfficeVillage: null,
        OfficePanchayath: null,
        OfficeTaluk: null,
        OfficeDistrict: 0,
        OfficeState: 1,
        OfficeCountryId: 1,
        NomineeAddress: null,
        NomineePlace: null,
        NomineePostOffice: null,
        NomineePincode: null,
        NomineeVillage: null,
        NomineePanchayath: null,
        NomineeTaluk: null,
        NomineeDistrict: 0,
        NomineeState: 1,
        NomineeCountryId: 1,
        EmployeeId: null,
        EmployeeBranchId: null,
        CompanyId: null,
        SaasId: null,
        CreatedDate: null,
        ModifiedDate: null,
        IsActive: true,
        Flag: 1,

        AnnualIncome: null,
        SurveyAmount: null,
        LoanPurposeId: 0,
        SurveyStatusId: null,

        IsCustomerSearch: false,
        IsPresentAddessSame: false,
        IsOfficeAddessSame: false,
        IsNomineeAddessSame: false,

        // for report
        ReportName: null,
        BranchId: 0,
        CentreId: 0,
        LoanTypeId: 0,
        LoanCategoryId: 0,
        SchemeId: 0,

        PhotoFileName: null,
        IdProofFileName: null,
        AddressProofName: null,
        PhotoFilePath: null,
        IdProofFilePath: null,
        AddressProofFilePath: null,
      }],

      EmployeeList: [{
        Id: null,
        Name: null,
        Code: null,
        UserName: null,
        Password: null,
        AreaId: null,
        RegionId: null,
        BranchId: null,
        CountryId: null,
        SaasId: null,
        IsActive: null,
        CompanyId: null,
      }],

      EnquiryNoList:[{
        Id: 0,
        EnquiryNo: null,
      }]

    }

  }

  getAutogeneratedNumber(): any {

    if (this.ParentSurveyNo == 101) {
      const myAutoGeneratedId = this.commonmastersService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.surveyentryService.selectedSurveyentry.SurveyNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
    else {
      this.surveyentryService.selectedSurveyentry.SurveyNo = this.ParentSurveyNo;
    }
  }

  GetStaff() {
    this.commonmastersService.FetchStaffList().subscribe(data => {
      this.StaffList = data;
    })
  }

  GetEnquiryNo() {
    this.enquiryentryService.FetchEnquiryEntryList().subscribe(data => {
      this.enquiryEntryNoList$ = data;
    })
  }

  AddNewCustomer(surveyNo: number) {
    this.router.navigate(['/customer', { Id: undefined, Id1: surveyNo }]);
  }

  onSubmit(form: NgForm) {
    // selecting the staff from selectedStaff
    if (this.selectedStaff != null && this.dataSource != undefined) {
      this.surveyentryService.selectedSurveyentry.EmployeeList = [];
      const myData = this.selectedStaff.map((row) => {
        let employee = new Employee();
        employee.Id = row;
        employee.Name = ' ';
        employee.Code = ' ';
        employee.UserName = ' ';
        employee.Password = ' ';
        employee.AreaId = 0;
        employee.RegionId = 0;
        employee.BranchId = 0;
        employee.CountryId = 0;
        employee.SaasId = ' ';
        employee.IsActive = 0;

        this.surveyentryService.selectedSurveyentry.EmployeeList.push(employee);
        // return { empList : this.enquiryentryService.selectedEnqiryentry.EmployeeList }
      });

      this.surveyentryService.selectedSurveyentry.EnquiryNoList =[];
      const myData1 = form.value.EnquiryNoList.map((row) => {

        let EnquiryNo = new Enquiryno();
        EnquiryNo.Id = 0;
        EnquiryNo.EnquiryNo = row;
        this.surveyentryService.selectedSurveyentry.EnquiryNoList.push(EnquiryNo);
      });

      form.value.EmployeeList = this.surveyentryService.selectedSurveyentry.EmployeeList;
      form.value.CustomersList = this.dataSource;
      form.value.EnquiryNoList = this.surveyentryService.selectedSurveyentry.EnquiryNoList;

      this.surveyentryService.IUDSurveyEntry(form.value)
        .subscribe(data => {
          this.router.navigate(['/surveyentrylist']);
        })

    }
  }

  selectEnquiryNoChange($event: any) {

    // this.surveyentryService.selectedSurveyentry.EnquiryNo = $event[0].Id;
    if($event != ''){
      this.surveyentryService.selectedSurveyentry.EnquiryDate = $event[0].EnquiryDate;
    }
    else{
      this.surveyentryService.selectedSurveyentry.EnquiryDate = null;
    }
  }

  selectStaffChange($event: any) {
    // console.log($event);
  }

  GetCustomers() {
    if (!Number.isNaN(this.ParentSurveyNo) && this.ParentSurveyNo != undefined
      && this.IsNewEntry != 101) {
      this.customerService.FetchSurveyNoCustomerList(this.ParentSurveyNo).subscribe(data => {
        this.dataSource = data;
      })
    }
  }

  EditCustomers(customerRow: any) {

    // if (this.IsNewEntry != 101 && this.IsNewEntry != 501) {
    if (this.IsNewEntry != 101 ) {
      this.router.navigate(['/customer', { Id: customerRow.Id , Id1: this.ParentSurveyNo }]);
    }
    else {
      this.router.navigate(['/customer', { Id: undefined , Id1: this.ParentSurveyNo }]);
    }
  }

  GetSurveyEntryBySurvayNo() {

    if (!Number.isNaN(this.ParentSurveyNo) && this.ParentSurveyNo != undefined
      && this.IsNewEntry != 101
      && this.IsNewEntry != 501) {
      this.surveyentryService.FetchSurveyEntryById(this.ParentSurveyNo).toPromise()
        .then(data => {

          // console.log(data);
          // console.log(data.EnquiryNo);

          this.surveyentryService.selectedSurveyentry.SurveyDate = data.SurveyDate;
          this.surveyentryService.selectedSurveyentry.EnquiryNo = data.EnquiryNo;
          this.surveyentryService.selectedSurveyentry.EnquiryDate = data.EnquiryDate;
          this.surveyentryService.selectedSurveyentry.StatusId = data.StatusId;
          this.surveyentryService.selectedSurveyentry.TrainingNo = data.TrainingNo;
          this.surveyentryService.selectedSurveyentry.Remarks = data.Remarks;
          this.surveyentryService.selectedSurveyentry.ProposedCenter = data.ProposedCenter;
          this.surveyentryService.selectedSurveyentry.FirstTrainingDate = data.FirstTrainingDate;
          this.surveyentryService.selectedSurveyentry.SecondTrainingDate = data.SecondTrainingDate;
          this.surveyentryService.selectedSurveyentry.ThirdTrainingDate = data.ThirdTrainingDate;

        })
        .catch(err => {
          console.log(err)
          this.surveyentryService.selectedSurveyentry.SurveyDate = new Date();
        });

    }
  }

  GetStaffBySurvayNo() {
    if (!Number.isNaN(this.ParentSurveyNo) && this.ParentSurveyNo != undefined) {
      this.commonmastersService.FetchStaffListById(this.ParentSurveyNo).subscribe(data => {

        for (var i = 0; i < data.length; i++) {
          // this.selectedStaff.push(data[i].Id,data[i].Name);
          this.selectedStaff.push(data[i]);
        }
        // console.log(this.selectedStaff);
      })
    }
  }

  GetCentreList() {
    this.centerlinkService.GetCentreList()
      .toPromise()
      .then(data => {
        this.CentreList = data;
      })
  }

}
